// @flow

import React from 'react';

import styled from 'styled-components';

import { SectionChild } from '../components/section';
import BaseComponent from '../lib/base-component';

import { isThemeiOS } from '../themes';

import {
  SmartButton,
  ValueWrapper,
  Value,
  Arrow
} from '../components/Common';

import { onLoadReason, removeHandler } from '../lib/load-reason';

const REDIRECT_SERVICE = `${window.location.protocol}//${window.location.host}/simple-redirect.html`;

const ItemTitle = styled.div`
  margin-right: 5px;
  color: inherit;
`;

const Status = styled(Value)`
  && {
    ${({ showError }) => showError ? 'color: red;' : ''}
  }
`;

export default class Webconfig extends BaseComponent {
  static _type = 'Webconfig';
  _type = 'Webconfig';

  state = {
    callbackUri: null
  };

  async componentWillMount() {
    const { uriString: callbackUri } = await window.__webview_comms__.get('webconfig-callback-uri');

    this.setState({
      callbackUri
    });

    onLoadReason(this.handleLoadReason);
  }

  componentWillUnmount() {
    removeHandler(this.handleLoadReason);
  }

  handleLoadReason = ({ loadReason, loadData }: * = {}) => {
    const { fullReturnUrl } = loadData || {};

    if (loadReason !== 'webconfig' || !fullReturnUrl) {
      return;
    }

    const returnUrl = new URL(fullReturnUrl);
    this.props.onReturn(returnUrl.search && returnUrl.search.replace('?', ''));
  }

  handleClick = () => {
    const webConfigUrl = this.props.constructUrl(REDIRECT_SERVICE, this.state.callbackUri);
    window.__webview_comms__.launch('webconfig', {
      webConfigUrl
    });
  };

  renderBody() {
    const { label, status, disabled, showError } = this.props;

    return (
      <SmartButton
        onClick={this.handleClick}
        disabled={disabled}
      >
        <ItemTitle>{label}</ItemTitle>
        <ValueWrapper>
          <Status showError={showError}>{status}</Status>
          {isThemeiOS() && <Arrow />}
        </ValueWrapper>
      </SmartButton>
    );
  }


  render() {
    const {title, description} = this.props;

    return (
      <SectionChild title={title} description={description}>
        {this.renderBody()}
      </SectionChild>
    );
  }
}



// WEBPACK FOOTER //
// ./src/fitbit-components/webconfig.js